import React, { useEffect, useRef, useState } from 'react'
import {Link, useNavigate} from 'react-router-dom';
import { Button } from 'antd';
import { SlLogout } from "react-icons/sl";
import Logo from '../../assets/logo.png'
import Pacientes from '../Pacientes';
import Calendario from '../Calendario';
import PatientMore from '../PatientMore';
import Codes from '../Codes';
import Users from '../Users'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const Home: React.FC = () => {
	const navigate = useNavigate()
	const back = () => {
		setGetPage(<Pacientes userId={getUserId}/>)
	}
	const getUserId = (id: string) => {
		setGetPage(<PatientMore userId={id} back={back} printDiv={printDiv}/>)
	}
	const [userName, setUserName] = useState()
	const [getPage, setGetPage] =  useState<JSX.Element | null>(<Pacientes userId={getUserId}/>);

	const printRef = useRef(null);
	
	const getUserData = () => {
		const user:any = sessionStorage.getItem('userData')
		const userJson:any = JSON.parse(user)
		const name:any = userJson.user.user
		if(user !== null){
			setUserName(name)
		}
	}

	const exitSession = () => {
		sessionStorage.setItem('userData', '')
		navigate('/')
	}

	useEffect(() => {
		if(sessionStorage.getItem('userData')){
			const user:any = sessionStorage.getItem('userData')
			const userJson:any = JSON.parse(user)
			const name:any = userJson.user.user
			if(name){
				getUserData()
			}else{
				navigate('/')
			}
		}else{
			navigate('/')
		}
	}, [])

	const printDiv = () => {
		const input: any = printRef.current; // ID del div a imprimir
		const margin = 10;
		let originalStyles: { [key: string]: string } = {};
		// Ocultar los botones
		const ocultar = document.getElementsByClassName('ocultarPrintDiv');
    	Array.from(ocultar).forEach(x => {
			const el = x as HTMLElement;
			originalStyles[el.className] = el.style.display; // Guardar el estilo de 'display'
			el.style.display = 'none'; // Ocultar
		});

		const incremento = 1

		const elementosP = document.getElementsByTagName('p');
		const elementosH1 = document.getElementsByTagName('h1');
		const elementosH2 = document.getElementsByTagName('h2');
		const elementosH3 = document.getElementsByTagName('h3');
		const elementosLi = document.getElementsByTagName('li');

		// Función para aumentar el tamaño de fuente
		const aumentarFontSize = (elementos: HTMLCollectionOf<Element>, tagName: string) => {
			Array.from(elementos).forEach((el, index) => {
			  const htmlEl = el as HTMLElement;
			  const currentSize = window.getComputedStyle(htmlEl).fontSize; // Obtener el tamaño actual
			  originalStyles[`${tagName}-${index}`] = currentSize; // Guardar el tamaño de fuente original
			  const newSize = parseFloat(currentSize) * (1 + incremento); // Calcular nuevo tamaño
			  htmlEl.style.fontSize = `${newSize}px`; // Establecer nuevo tamaño
			});
		};

		// Llamar a la función para cada tipo de elemento
		aumentarFontSize(elementosP, 'p');
		aumentarFontSize(elementosH1, 'h1');
		aumentarFontSize(elementosH2, 'h2');
		aumentarFontSize(elementosH3, 'h3');
		aumentarFontSize(elementosLi, 'li');
	
		html2canvas(input).then((canvas) => {
			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF();
			
			// Ajusta el tamaño del PDF según la imagen
			const imgWidth = pdf.internal.pageSize.getWidth() - margin * 2; // Ajusta según el ancho del PDF
			const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;
			const imgHeight = ((canvas.height * imgWidth) / canvas.width) - margin * 2;
			let heightLeft = imgHeight;
		
			let position = 0;
		
			// Agrega la imagen al PDF
			pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;
		
			// Si la imagen es más alta que la página, agrega nuevas páginas
			while (heightLeft >= 0) {
				position = heightLeft - imgHeight; // Calcula la posición
				pdf.addPage();
				pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
				heightLeft -= pageHeight; // Reduce la altura restante
			}
		
			// Guarda el PDF
			pdf.save('historia.pdf');

			Array.from(ocultar).forEach(x => {
				const el = x as HTMLElement;
				el.style.display = originalStyles[el.className] || ''; // Restaurar el estilo de 'display'
			});

			const restaurarFontSize = (elementos: HTMLCollectionOf<Element>, tagName: string) => {
				Array.from(elementos).forEach((el, index) => {
				const htmlEl = el as HTMLElement;
				const originalSize = originalStyles[`${tagName}-${index}`]; // Obtener el tamaño original guardado
				if (originalSize) {
					htmlEl.style.fontSize = originalSize; // Restaurar el tamaño original
				}
				});
			};

		  	restaurarFontSize(elementosP, 'p');
			restaurarFontSize(elementosH1, 'h1');
			restaurarFontSize(elementosH2, 'h2');
			restaurarFontSize(elementosH3, 'h3');
			restaurarFontSize(elementosLi, 'li');
		});
	};

	return(
		<div>
			<div className='flex justify-between px-5 py-2 items-center'>
				<div><img src={Logo} className='h-12'/></div>
				<div className='flex flex-row text-text-menu'>
					<SlLogout size={25} onClick={exitSession} style={{cursor: 'pointer'}}/>&nbsp;
					Bienvenid@, {userName}
				</div>
			</div>
			<div className='bg-holistic py-2 ocultarPrintDiv'>
				<Button onClick={() => setGetPage(<Pacientes userId={getUserId}/>)} type='link'><span className='text-text-menu'>Pacientes</span></Button>
				<Button onClick={() => setGetPage(<Calendario />)} type='link'><span className='text-text-menu'>Calendario</span></Button>
				<Button type='link'><a href="holistica.pdf" target="_blank" style={{color: '#B71C1C'}}>C. Acupuntura y Neural</a></Button>
				<Button type='link'><a href="sueroterapia.pdf" target="_blank"  style={{color: '#B71C1C'}}>C. SueroTerapia</a></Button>
				<Button onClick={() => setGetPage(<Codes />)} type='link'><span className='text-text-menu'>Códigos</span></Button>
				<Button onClick={() => setGetPage(<Users />)} type='link'><span className='text-text-menu'>Usuarios</span></Button>
			</div>
			<div ref={printRef}>
				{getPage}
			</div>
		</div>
	)
}

export default Home